import type { ActorRefFrom } from 'xstate'
import type multiCartMachine from './multiCartMachine'

/**
 * Leaf accessor for the live MultiCart XState actor.
 * Kept out of MultiCartMachineProvider so analytics/utils can read the actor
 * without importing the provider (and the multiCartMachine → snowplow/events cycle).
 */
export type CartMachineActor = ActorRefFrom<typeof multiCartMachine>

let globalCartMachineActor: CartMachineActor | null = null

export function getCartMachineActor(): CartMachineActor | null {
  return globalCartMachineActor
}

export function setCartMachineActor(actor: CartMachineActor | null): void {
  globalCartMachineActor = actor
}
